import Service from "../../AuthService";

const TaxInvoice = {
    getTaxInvoice(page) {
        return Service.get("/tax_invoice?page="+page);
    },
    showTaxInvoice(id) {
        return Service.get("/tax_invoice/" + id);
    },
    updateTaxInvoice(id, data) {
        return Service.put("/tax_invoice/" + id, data);
    },
    createTaxInvoice(data) {
        return Service.post("/tax_invoice", data);
    },
    deleteTaxInvoice(id) {
        console.log("/tax_invoice/" + id);
        return Service.delete("/tax_invoice/" + id);
    },
    searchTaxInvoice(page,data){
        return Service.post('/tax_invoice_search?page='+page,data);
    },
    selectTaxInvoiceAll(){
        return Service.get('/selectTaxInvoiceAll');
    },
    getInvoiceByStatusTax(){
        return Service.get('/get_invoice_by_status_tax');
    },
    printMultipleTax(id){
        return Service.get('/merge/tax_merge_pdf?id='+id);
    },
};

export default TaxInvoice
